/* eslint-disable */
import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { Box, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";

function CurrentSearchResultChart({ chartData }) {
  const renderLegend = () =>
    chartData.map((entry, index) => (
      <ListItem key={index} disableGutters>
        <ListItemIcon className="litsItemIconBox">
          <CircleIcon style={{ color: entry.color }} />
        </ListItemIcon>
        <ListItemText className="listitemText" primary={entry.name} secondary={`${entry.value} `} />
      </ListItem>
    ));

  return (
    <Box className="chartMainWrapperBox">
      <Box className="chartWrapper">
        <PieChart width={100} height={100}>
          <Pie data={chartData} dataKey="value" cx="50%" cy="50%" innerRadius={30} outerRadius={50} fill="#8884d8">
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </Box>
      <Box className="renderLegend">
        <List>{renderLegend()}</List>
      </Box>
    </Box>
  );
}

export default CurrentSearchResultChart;
